import CityPageTemplate from "../city-template/CityPageTemplate";
import { fresnoConfig } from "./data";

export default function FresnoPage() {
  return <CityPageTemplate config={fresnoConfig} />;
}